module.exports = {"TXTWCL_Claim_your_bonus":{"id":"TXTWCL_Claim_your_bonus","defaultMessage":"Получите свой бонус","track":"Claim your bonus"}}